import useHomeData from "@/views/home/useHomeData.js";
import useCategoriesData from "@/views/categories/useCategoriesData.js";
import useCategoryData from "@/views/category/useCategoryData.js";
import useSettingsData from "@/views/settings/useSettingsData.js";
import useEntryData from "@/views/person/useEntryData.js";
import useRecentlyDeletedData from "@/views/recentlyDeleted/useRecentlyDeletedData.js";
import useSiteNavigator from "@/util/useSiteNavigator.js";

export default function useViewData() {
  const { loadHomeData } = useHomeData();
  const { loadCategoriesData } = useCategoriesData();
  const { loadCategoryData } = useCategoryData();
  const { loadSettingsData } = useSettingsData();
  const { loadEntryData } = useEntryData();
  const { loadRecentlyDeletedData } = useRecentlyDeletedData();
  const { updateSiteNavigator } = useSiteNavigator();

  async function loadViewData(to) {
    const { name, params } = to;

    switch (name) {
      case "Home":
        return loadHomeData();
      case "Settings":
        return loadSettingsData(to);
      case "RocketCast":
        return loadSettingsData(to);
      case "SEO":
        return loadSettingsData(to);
      case "General":
        return loadSettingsData(to);
      case "Analytics":
        return loadSettingsData(to);
      case "Fonts":
        return loadSettingsData(to);
      case "Users":
        return loadSettingsData(to);
      case "Categories":
        return loadCategoriesData(params);
      case "SubCategories":
        return loadCategoriesData(params, true);
      case "Category":
        return loadCategoryData(params);
      case "Person":
        return loadEntryData(params);
      case "BulkCategoryEditor":
        return loadCategoryData(params);
      case "BulkRecordItemsEditor":
        return loadCategoryData(params);
      case "RecentlyDeleted":
        return loadRecentlyDeletedData();
      default:
    }

    await updateSiteNavigator(to.params);
    return undefined;
  }

  return { loadViewData };
}
